/* ******************** NPM ******************** */
// jQuery
import "./base/_jquery-global";

// Popper.js (* tooltip, popover, dropdown)
import * as Popper from "@popperjs/core";

// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
// import "bootstrap/js/dist/collapse";

/* ******************** BASE ******************** */
// Import utilities as needed
import {
    utl_pageId,
    utl_setFooterYear,
    utl_handleModalClose,
    utl_ehElements,
    utl_anchorScrollOffset,
    // utl_toggleCookiesAlert,
} from "./base/_utils";

// Call utility functions after imported
utl_setFooterYear();
utl_handleModalClose();
utl_ehElements();
utl_anchorScrollOffset();
// utl_toggleCookiesAlert();

/* ******************** COMPONENTS ******************** */
import customInit from "./components/_custom";
import randomImgInit from "./components/_random-image";
import carouselsInit from "./components/_carousels";

customInit();
utl_pageId !== "main-index" && randomImgInit();
carouselsInit();

/* ******************** PAGES ******************** */
// Individual page scripts are added in the header of specific page's index file
